var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3934 2.02096C13.7839 1.63043 13.7839 0.997266 13.3934 0.606742C13.0028 0.216218 12.3697 0.216218 11.9792 0.606743L13.3934 2.02096ZM0.665445 11.9205C0.274921 12.311 0.274921 12.9441 0.665445 13.3347C1.05597 13.7252 1.68913 13.7252 2.07966 13.3347L0.665445 11.9205ZM2.07966 0.606742C1.68913 0.216218 1.05597 0.216218 0.665445 0.606743C0.274921 0.997267 0.274921 1.63043 0.665445 2.02096L2.07966 0.606742ZM11.9792 13.3347C12.3697 13.7252 13.0028 13.7252 13.3934 13.3347C13.7839 12.9441 13.7839 12.311 13.3934 11.9204L11.9792 13.3347ZM11.9792 0.606743L0.665445 11.9205L2.07966 13.3347L13.3934 2.02096L11.9792 0.606743ZM0.665445 2.02096L11.9792 13.3347L13.3934 11.9204L2.07966 0.606742L0.665445 2.02096Z",
    fill: "#23273B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c8449cc9a7fa97302071c01a3c0ab8b8.svg";
export { ForwardRef as ReactComponent };